import { styled } from '@mui/material';
import Stack from '@mui/material/Stack';

const StyledStack = styled(Stack, {
  shouldForwardProp: (prop) => prop !== 'fullWidth',
})<{ fullWidth?: boolean }>(({ theme, fullWidth }) => ({
  alignItems: 'flex-start',
  gap: theme.spacing(1.5),
  flex: fullWidth ? 1 : 'unset',
}));

export default StyledStack;
